import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  return (
    <section className="bg-background-50 py-12 md:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="text-center mb-10">
          <p className="text-xs font-semibold text-foreground-500 uppercase tracking-[0.2em] mb-3">
            Browse Categories
          </p>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            Kategorien durchstöbern
          </h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4 max-w-6xl mx-auto">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col bg-background-100 rounded-xl border border-background-200/70 hover:border-primary-300 hover:shadow-sm transition-all duration-200 cursor-pointer overflow-hidden"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="flex items-center gap-2 p-3">
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50 text-primary-600 group-hover:bg-primary-100 group-hover:text-primary-700 transition-colors shrink-0">
                  <i className={`${cat.icon} text-sm`}></i>
                </span>
                <span className="text-xs font-medium text-foreground-700 leading-tight group-hover:text-primary-700 transition-colors">
                  {cat.name}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}